import * as actionTypes from "../actions/actionTypes";
// Action for Allocate satus

export const applyFilterQuotation = (filterPossition) => {
    return {
        type: actionTypes.UPDATE_FILTER_TAB_POSSITION,
        filterSwitchTab: filterPossition,
    }
}